<style scoped>
.box1 {
  padding-top: 20px;
  padding-bottom: 30px;
  padding-left: 30px;
  padding-right: 30px;
  /*margin-top: 10px;*/
  text-align: left;
}
.pays-box {
  /*margin-top: 15px;*/
  margin-bottom: 15px;
  height: 100%;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
  text-align: left;
}
.pays-table {
  padding: 10px;
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
}
.pays-table-header {
  border-bottom: 1px solid var(--color-border);
  padding: 10px;
  text-align: left;
  font-size: 14px;
}
.pays-table-cell {
  /*border-bottom: 1px solid var(--color-border);*/
  padding: 10px;
  text-align: left;
  font-size: 16px;
}
.tablerow {
  background-color: var(--color-card-dark);
  height: 32px;
  cursor: pointer;
}
.tablerow:hover {
  background-color: var(--color-background);
}
.oddrow {
  background-color: var(--color-card);
}
.textStyle {
  font-size: 16px;
}
.planExpiryText {
  font-size: 16px;
  color: var(--color-info);
}
.plan-cell {
  /*padding: 20px;*/
  /*height: 300px;*/
  /*width: 23%;*/
  /*min-width: 300px;*/
}

.plans {
  margin-top: 30px;
  /*display: flex;*/
  display: grid;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 40px;
}

.flexcenter {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flexspacebetween {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.violet {
  background: linear-gradient(
    to bottom left,
    var(--color-accent-dark),
    var(--color-accent)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.panename {
  font-size: 18px;
  color: var(--color-text-dark);
}

.header1 {
  font-size: 18px;
  color: var(--color-text-dark);
}

.text1 {
  font-size: 20px;
}

.discountExpiry {
  font-size: 16px;
  color: darkgrey;
}

.free-sub-box {
  /*border: 1px solid #232838;*/
  border-radius: 10px;
  /*padding: 20px;*/
}
a:hover {
  text-decoration: underline;
}

td {
  /*border: 1px dotted forestgreen;*/
}

div {
  /*border: 1px dotted deeppink;*/
}

#pay {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 10px;
}

@media all and (max-width: 1000px) {
  .plans {
    grid-template-columns: repeat(2, 1fr);
    grid-template-row: auto;
  }
}
</style>

<template>
  <div id="pay">
    <div class="box box1">
      <PayModal
        :show="showPayModal"
        :address="payAddress"
        :amount="payAmount"
        :asset="payAsset"
        :amountUsd="payAmountUsd"
        :status="payStatus"
        :id="payId"
        @on-cancel="showPayModal = false"
      ></PayModal>
      <!--        <div class="flexcenter panename">Оплата</div><br>-->
      <div class="flexspacebetween">
        <div style="height: 90px;">
          <div
            v-if="planExpiryText === ' '"
            class="header1"
          ></div>
          <div
            v-else-if="planExpiryText !== ''"
            class="header1"
          >{{ $text.tr('ПОДПИСКА АКТИВНА ДО') }}
            <Tooltip
              max-width="330"
              placement="right-start"
              :content="hint"
            >
              <Icon
                style="color: var(--color-neutral); margin-bottom: 3px"
                type="ios-information-circle-outline"
              ></Icon>
            </Tooltip>
          </div>
          <div
            v-else
            class="header1"
          > <span style="color: var(--color-neutral)">{{ $text.tr('ПОДПИСКА ЗАКОНЧИЛАСЬ') }}</span>
            <Tooltip
              max-width="330"
              placement="right-start"
              :content="hint"
            >
              <Icon
                style="color: var(--color-neutral); margin-left: 3px; margin-bottom: 3px"
                type="ios-information-circle-outline"
              ></Icon>
            </Tooltip>
          </div>
          <div class="text1">{{ planExpiryText }}</div>
        </div>
        <div
          v-if="discount !== '0'"
          style="text-align: right;"
        >
          <div class="header1">{{ $text.tr('ПЕРСОНАЛЬНАЯ СКИДКА') }}</div>
          <div class="text1"><span>{{ discount }}%</span> </div>
          <div class="discountExpiry">{{ discountText }}</div>
        </div>
      </div>
      <div class="free-sub-box">
        <div class="header1">{{ $text.tr('ТОРГУЙТЕ БЕСПЛАТНО:') }}</div>
        <ul style="margin-left: 20px; margin-top: 5px;">
          <li>{{ $text.tr('НА ДЕМО БИРЖЕ') }}</li>
          <li>{{ $text.tr('НА БИРЖЕ') }}
            <a
              :href="$text.tr('https://doc.capico.app/v/ru/ex/api/okx')"
              target="_blank"
              style="color: var(--color-info); font-size: 14px"
            >OKX</a>
          </li>
          <li>
            {{ $text.tr('НА СПЕЦИАЛЬНОМ ТАРИФЕ ДЛЯ') }}
            <a
              :href="$text.tr('https://doc.capico.app/v/ru/ex/api/binance')"
              target="_blank"
              style="color: var(--color-info); font-size: 14px"
            >BINANCE</a>,
            <a
                :href="$text.tr('https://doc.capico.app/v/ru/ex/api/bybit')"
                target="_blank"
                style="color: var(--color-info); font-size: 14px"
            >BYBIT</a>
            {{ $text.tr('и').toUpperCase() }}
            <a
              :href="$text.tr('https://doc.capico.app/v/ru/ex/api/huobi')"
              target="_blank"
              style="color: var(--color-info); font-size: 14px"
            >HTX</a>
          </li>
        </ul>
        <!--          <br>-->
        <!--          <div class="header1">{{ $text.tr('ПРОМО:') }}</div>-->
        <!--          <ul style="margin-left: 20px; margin-top: 5px;">-->
        <!--            <li><span style="padding-right: 10px;">{{ $text.tr('СКИДКА 10% ПРИ ОПЛАТЕ ПОДПИСКИ В ТОКЕНАХ GR') }}</span>-->
        <!--            <a :href="$text.tr('https://capico.app/info/p/3e5b035c-16ad-4768-9857-fbbe8e778ebf/')" target="_blank" style="color: var(--color-info); font-size: 14px;">{{ $text.tr('ИНФОРМАЦИЯ') }}</a>-->
        <!--            </li>-->
        <!--          </ul>-->
      </div>
      <br>
      <div class="plans">
        <div
          class="plan-cell"
          v-for="(plan) in plans"
          :key="plan.period"
          v-on:click="planSelected(plan.period)"
        >
          <Plan
            :period="plan.period"
            :cost="plan.cost"
          />
        </div>
      </div>
      <div
        class="flexcenter header1"
        style="margin-top: 60px;"
      >{{ $text.tr('ВАЛЮТА ОПЛАТЫ') }}</div>
      <RadioGroup
        v-model='asset'
        type="button"
        style="margin-top: 10px; margin-bottom: 40px; width: 100%; text-align: center;"
      >
        <Radio
          style="width: 110px;"
          v-for="as in assets"
          :key="'asset-'+as"
          :label='as'
          size='large'
        >
        </Radio>
      </RadioGroup>
      <br>
      <div
        v-if="discount !== '0'"
        style="width: 100%; text-align: center; margin-bottom: 20px"
      >
        <span class="header1">{{ $text.tr('СУММА C УЧЕТОМ СКИДКИ') }} ({{ discount }}%)</span><br>
        <span class="text1">${{ amountUsd }}</span>
      </div>
      <div class="flexcenter">
        <div style="width: 200px; margin-top: 20px;">
          <Button
            long
            @click="createPayment"
            :loading="disablePayBtn"
            :disabled="disablePayBtn"
            size="large"
          >{{ $text.tr('ОПЛАТИТЬ') }} ${{ amountUsd }}</Button>
        </div>
      </div>
      <div
        class="flexcenter"
        style="margin-top: 25px;"
      >
        <a
          :href="$text.tr('https://doc.capico.app/v/ru/plans/subscription')"
          target="_blank"
          style="color: var(--color-info); font-size: 12px"
        >{{ $text.tr('ИНСТРУКЦИЯ ПО ОПЛАТЕ') }}</a>
      </div>
    </div>
    <div class="box pays-box">
      <div class="flexcenter panename">{{ $text.tr('ИСТОРИЯ ПЛАТЕЖЕЙ') }}</div>
      <table class="pays-table">
        <br>
        <tr>
          <th class="pays-table-header">ID</th>
          <th class="pays-table-header">{{ $text.tr('ДАТА') }}</th>
          <th class="pays-table-header">{{ $text.tr('ПЕРИОД') }}</th>
          <th class="pays-table-header">{{ $text.tr('СУММА') }}, $</th>
          <th class="pays-table-header">{{ $text.tr('СУММА') }}</th>
          <th class="pays-table-header">{{ $text.tr('СТАТУС') }}</th>
        </tr>
        <template v-for="(pay, index) in paysList">
          <tr
            :key="pay.Id"
            class="tablerow"
            :class="{'oddrow': index % 2 === 0}"
            v-on:click="paySelected(index)"
          >
            <td class="pays-table-cell">{{ pay.Id }}</td>
            <td class="pays-table-cell">{{ localTime(pay.Updated) }}</td>
            <td class="pays-table-cell">{{ pay.Period }}{{ $text.tr('м') }}</td>
            <td class="pays-table-cell">${{ pay.AmountUsd }}</td>
            <td class="pays-table-cell">{{ pay.Amount}} {{ pay.Asset }}</td>
            <td
              class="pays-table-cell"
              style="color: var(--color-info)"
            >{{ $text.tr(returnStatus(pay.Status)) }}</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import PayModal from '@/components/MainPage/Pay/PayModal'
import Plan from '@/components/MainPage/Pay/Plan'
import PayApi from '@/util/payapi'
import Decimal from 'decimal.js'
import util from '@/util/util'

export default {
  name: 'Pay',
  components: { Plan, PayModal },
  data: function () {
    return {
      hint: this.$text.tr(`После окончания подписки недоступно:
- добавление новых счетов
- создание и редактирование смарт-сделок и ботов
- установка и редактирование Stop Loss и Take Profit`),
      payId: '',
      amountUsd: '',
      payStatus: '',
      payAmountUsd: '',
      disablePayBtn: false,
      plans: [
        { period: '1', cost: 15 },
        { period: '3', cost: 39 },
        { period: '6', cost: 69 },
        { period: '12', cost: 119 }
      ],
      // plans: [
      //   { period: '1', cost: 19 },
      //   { period: '3', cost: 54 },
      //   { period: '6', cost: 99 },
      //   { period: '12', cost: 169 }
      // ],
      payAmount: '',
      payAddress: '',
      showPayModal: false,
      planExpiry: '',
      discount: '',
      discountExpiry: '',
      // assets: ['BTC', 'LTC', 'USDT TRC20', 'BUSD BSC'],
      assets: ['BTC', 'LTC', 'USDT BSC', 'USDT POLYGON'],
      payAsset: 'LTC',
      asset: 'LTC',
      paysList: [],
      getInfoInterval: null
      //   [
      //   { Id: 'arst', Period: 1, AmountUsd: 15, Amount: 0.0013898, Asset: 'BTC', Created: '2019-06-17 14:34:22.18674', Status: 'ACT' },
      //   { Id: 'rstd', Period: 1, AmountUsd: 15, Amount: 0.0942629, Asset: 'LTC', Created: '2019-06-17 14:34:22.18674', Status: 'WAI' },
      //   { Id: 'roti', Period: 3, AmountUsd: 45, Amount: 0.0036351, Asset: 'BTC', Created: '2019-06-17 14:34:22.18674', Status: 'PAY' }
      // ]
    }
  },
  watch: {
    $route (to, from) {
      // console.log('route:', to)
      if (to.name === 'pay') {
        this.createIntervals()
      }
      if (from.name === 'pay') {
        this.clearIntervals()
      }
    }
  },
  computed: {
    discountText () {
      if (this.discount.length === 0) {
        return ''
      }
      const expiryDate = new Date(this.discountExpiry)
      const res = this.countOfDaysTillExpiryDay(expiryDate)
      return (
        ' ' +
        this.$text.tr('активна до') +
        ' ' +
        this.timeFormat(this.discountExpiry) +
        ' (' +
        res +
        ' ' +
        this.$text.tr('дн.') +
        ')'
      )
    },
    discountAct () {
      const expiryDate = new Date(this.discountExpiry)
      const now = new Date()
      if (expiryDate > now) {
        return true
      }
      return false
    },
    planExpiryText () {
      let status = ''
      if (this.planExpiry.length === 0) {
        return ' '
      }
      const expiryDate = new Date(this.planExpiry)
      const now = new Date()
      if (expiryDate > now) {
        const res = this.countOfDaysTillExpiryDay(expiryDate)
        // status = 'активна до ' + this.timeFormat(this.planExpiry) + ' (' + res + ' дн.)'
        status =
          this.timeFormat(this.planExpiry) +
          ' (' +
          res +
          ' ' +
          this.$text.tr('дн.') +
          ')'
      }
      const defaultExpiryDate = new Date('2019-07-01')
      // console.log(expiryDate)
      // console.log(defaultExpiryDate)
      if (expiryDate.getTime() === defaultExpiryDate.getTime()) {
        status = ' '
      }
      return status
    }
  },
  created () {
    this.finalAmountUsd()
    this.createIntervals()
  },
  destroyed () {
    this.clearIntervals()
  },
  methods: {
    countOfDaysTillExpiryDay (expiryDate) {
      const oneDay = 24 * 60 * 60 * 1000
      const countDays = Math.round(
        Math.abs((expiryDate.getTime() - new Date().getTime()) / oneDay)
      )
      // var dayText = 'дней'
      // if (countDays === 1) {
      //   dayText = 'день'
      // } else if (countDays > 1 && countDays < 5) {
      //   dayText = 'дня'
      // }
      return countDays
    },
    createIntervals () {
      this.getInfo()
      this.getInfoInterval = setInterval(this.getInfo, 10000)
      // console.log('getInfo interval created')
    },
    clearIntervals () {
      clearInterval(this.getInfoInterval)
      // console.log('getInfo interval cleared')
    },
    finalAmountUsd () {
      const planCost = new Decimal(
        this.plans.find(
          plan => plan.period === this.$store.state.pay.selectedPeriod
        ).cost
      )
      if (planCost === null) {
        this.amountUsd = ''
        return
      }
      let discountAmount = new Decimal(0)
      if (this.discountAct) {
        discountAmount = new Decimal(this.discount)
      }
      this.amountUsd = planCost
        .mul(new Decimal(100).sub(discountAmount))
        .div(100)
    },
    paySelected (index) {
      const pay = this.paysList[index]
      if (pay) {
        this.payAmountUsd = pay.AmountUsd
        this.payAddress = pay.Address
        this.payAsset = pay.Asset
        this.payAmount = pay.Amount
        this.showPayModal = true
        this.payStatus = this.returnStatus(pay.Status)
        this.payId = pay.Id
      }
    },
    timeFormat (utctime) {
      const date = new Date(utctime)
      const formatter = new Intl.DateTimeFormat('ru', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      })
      return formatter.format(date).replace(',', '')
    },
    localTime (utctime) {
      return new Date(utctime).toLocaleString('ru-RU').replace(',', '')
    },
    getInfo () {
      // console.log("pay info")
      const ref = this
      PayApi.get('info', {
        params: {
          token: this.$store.state.sys.token
        }
      })
        .then(function (response) {
          // console.log(response.data)
          if (!response.data.err) {
            // ok
            ref.paysList = response.data.Pays
            ref.discount = response.data.Discount
            ref.discountExpiry = response.data.DiscountExpiry
            ref.planExpiry = response.data.PlanExpiry
            ref.finalAmountUsd()
          } else {
            // error
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        })
        .catch(function (error) {
          // error
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    planSelected (id) {
      this.$store.state.pay.selectedPeriod = id
      this.finalAmountUsd()
      // console.log(id)
    },
    createPayment () {
      this.disablePayBtn = true
      this.payAsset = this.asset.replace(' ', '')
      this.payAmountUsd = this.amountUsd
      this.payStatus = this.returnStatus('ACT')
      this.payId = ''
      const ref = this
      PayApi.get('pay/new', {
        params: {
          token: this.$store.state.sys.token,
          period: this.$store.state.pay.selectedPeriod,
          asset: this.payAsset
        }
      })
        .then(function (response) {
          // console.log(response.data)
          if (!response.data.err) {
            // ok
            ref.payAddress = response.data.Address
            ref.payAmount = response.data.Amount
            ref.showPayModal = true
            ref.disablePayBtn = false
            ref.getInfo()
          } else {
            // error
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: util.returnTextForErr(response.data.err),
              duration: 10
            })
            ref.disablePayBtn = false
          }
        })
        .catch(function (error) {
          // error
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: util.returnTextForErr(error),
            duration: 10
          })
          ref.disablePayBtn = false
        })
    },
    returnStatus (s) {
      switch (s) {
        case 'WAI':
          return 'в обработке'
        case 'ACT':
          return 'ожидает оплаты'
        case 'PAY':
          return 'оплачен'
        default:
          return ''
      }
    }
  }
}
</script>
